import { createApp } from 'vue'
import StafetDeltagPaaHoldFlow from './StafetDeltagPaaHoldFlow'
import isObjectNotNullOrEmpty from 'foundation/js/isObjectNotNullOrEmpty'

const el = '.kb-component--stafet-join-a-team-flow'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDeltagPaaHoldFlowDOM) => {
            const externalData = StafetDeltagPaaHoldFlowDOM.dataset.external
                ? JSON.parse(StafetDeltagPaaHoldFlowDOM.dataset.external)
                : null

            const props = {
                stafetId: externalData.stafetId ?? null,
                holdId: externalData.holdId ?? null,
                tshirtSizes: externalData.tshirtSizes ?? [],
                holdList: externalData.holdList ?? [],
                userData: isObjectNotNullOrEmpty(externalData.userData)
                    ? externalData.userData
                    : null,
                donationAmounts: externalData.amounts ?? [], // { amountLabel: string, amount: number }
                loggedIn: isObjectNotNullOrEmpty(externalData.userData),
                lysposeMinimumAmount: externalData.lysposeMinimumAmount ?? 50,
                adultPrice: externalData.adultPrice,
                childPrice: externalData.childPrice,
                lysposeQuantityOption1: externalData.lysposeQuantityOption1 ?? 1,
                lysposeQuantityOption2: externalData.lysposeQuantityOption2 ?? 5,
                lysposeQuantityOption3: externalData.lysposeQuantityOption3 ?? 10,
                redirectToEditProfile: externalData.redirectToEditProfile,
                editProfileLinkText: externalData.editProfileLinkText,
            }
            const component = createApp(StafetDeltagPaaHoldFlow, props).use(
                Store
            )
            component.mount(StafetDeltagPaaHoldFlowDOM)
        })
    }
}
